@if (sharedStudents?.length) {
  <nz-tabs (nzSelectedIndexChange)="changeShared($event)">
    <nz-tab nzTitle="本班详情"></nz-tab>
    <nz-tab nzTitle="他班典型"></nz-tab>
  </nz-tabs>
}
<ng-container>
  <nz-table
    nzSize="small"
    #studentScoreTable
    [nzData]="tableData"
    [nzTotal]="tableData.length"
    [nzShowPagination]="tableData.length > 100"
    (nzCurrentPageDataChange)="changeCurrentPageData($event)"
    [nzPageSize]="tableData.length > 100 ? 30 : tableData.length"
  >
    <thead>
      <tr>
        @if (!showSharedStudents) {
          <th
            [nzShowCheckbox]="true"
            [(nzChecked)]="checked"
            [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onCheckAll()"
            nzWidth="50px"
          ></th>
        }
        <th nzWidth="160px">
          姓名
          <nz-filter-trigger
            [nzDropdownMenu]="searchNameMenu"
            [nzActive]="searchName.length > 0"
            [(nzVisible)]="searchNameVisible"
            class="float-right mt-sm"
          >
            <i nz-icon nzType="search"></i>
          </nz-filter-trigger>
          <nz-dropdown-menu #searchNameMenu="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="task_analysis_search-name-box">
                <input type="text" nz-input placeholder="姓名" [(ngModel)]="searchName" />
                <button nz-button nzSize="small" nzType="primary" class="search-button" (click)="onSearchName()">
                  搜索
                </button>
                <button nz-button nzSize="small" class="ml-sm" (click)="resetSearchName()">重置</button>
              </div>
            </div>
          </nz-dropdown-menu>
        </th>
        <th
          nzWidth="100px"
          [nzFilterFn]="filterScoreFn"
          [nzFilters]="filterScore"
          nzSortOrder="descend"
          [nzSortFn]="sortScoreFn"
        >
          得分
        </th>
        @if (hasShared) {
          <th>分享原因</th>
        }
        @if (questionStatis.model !== QuestionType.Stem) {
          <th [nzFilterFn]="filterAnswerFn" [nzFilters]="filterAnswer">作答</th>
        }
        @if (showDurationColumn) {
          <th nzWidth="90px" [nzSortFn]="sortDurationFn">作答时间</th>
        }
        @if (!showSharedStudents && !isStem) {
          <th
            [nzFilterMultiple]="false"
            [nzFilterFn]="filterCollectionFn"
            [nzFilters]="[
              { text: '已标记', value: true },
              { text: '未标记', value: false },
            ]"
          >
            标记
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (student of studentScoreTable.data; track $index) {
        <tr>
          @if (!showSharedStudents) {
            <td [nzShowCheckbox]="true" [(nzChecked)]="student.checked" (nzCheckedChange)="checkChecked()"></td>
          }
          <td>{{ student.firstName }}</td>
          <td>{{ student.score }}</td>
          @if (hasShared) {
            <td>{{ student.reason }}</td>
          }
          @if (questionStatis.model !== QuestionType.Stem) {
            <td>
              <div class="flex items-center flex-wrap select-none gap-2">
                @if (student.unfilled) {
                  <span>未作答</span>
                } @else if (student.answer) {
                  <span>{{ student.answer }}</span>
                }
                @for (photo of student?.photos; track photo) {
                  @if (photo.includes('**')) {
                    <span
                      nz-icon
                      nz-tooltip
                      class="point"
                      nzTheme="outline"
                      nzType="file-unknown"
                      nzTooltipTitle="导入成绩没有照片"
                    ></span>
                  } @else {
                    <img
                      [src]="photo | thumbnail: 32"
                      (click)="onReviewAnswerImages(student, currentPageData)"
                      class="w-[32px] h-[24px] object-cover rounded cursor-zoom-in"
                    />
                  }
                }
              </div>
            </td>
          }
          @if (showDurationColumn) {
            <td>{{ student.duration | timeSpan: 'secondText' }}</td>
          }
          @if (!showSharedStudents && !isStem) {
            <td>
              <button
                nz-button
                [nzShape]="'circle'"
                [nzType]="(!!student.flag && 'primary') || 'dashed'"
                nzSize="small"
                (click)="$event.stopPropagation(); flagExerciseDetail(student)"
              >
                <nz-icon nz-icon nzIconfont="icon-biaoji" />
              </button>
              @if (student.flagLabel && student.flag > 1) {
                <nz-tag class="ml-[8px]" [nzColor]="student.flag >= 200 ? 'red' : 'green'">
                  {{ student.flagLabel }}
                </nz-tag>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </nz-table>
</ng-container>
<div class="footer" nz-row nzJustify="space-between" nzAlign="middle">
  <div class="ml-md">
    @if (selectLength) {
      已选: {{ selectLength }}人
    }
  </div>
  <button nz-button (click)="createTargetClassroom()">创建靶向班</button>
</div>

